export default "__VITE_PUBLIC_ASSET__40391dcd__"